<template>
  <div :class="$style.highlights">
    <div :class="$style.header">
      <Sparkles :class="$style.icon" />
      <h3 :class="$style.title">{{ t('neighbourhood.insights.aiSummaryTitle') }}</h3>
    </div>
    <p :class="$style.text">{{ text }}</p>
  </div>
</template>

<script setup lang="ts">
import { Sparkles } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  text: string;
}>();
</script>

<style module lang="scss">
@import '@/assets/variables';

.highlights {
  padding: 24px;
  background: linear-gradient(47.83deg, #d3ecff 1.35%, #ccffe2 97.06%);
  border-radius: 12px;
  margin-bottom: 24px;
}

.header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}

.icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: #333333;
}

.title {
  font-size: 22px;
  font-weight: 800;
  color: #333333;
  margin: 0;
  line-height: 33px;
}

.text {
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  margin: 0;
  white-space: normal;
}
</style>
